<select [id]="field.fieldId" [(ngModel)]="field.value" (change)="handleSelectionChange($event)" [disabled]="disabled"
  [attr.name]="'field-' + field.fieldId"
  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
  <option disabled value="null" selected>{{ 'Select an option' }}</option>
  <ng-container *ngFor="let option of field.options; let i = index">
    <option [value]="option">{{ option }}</option>
  </ng-container>
</select>
